import React from "react";
import { Loader2 } from "lucide-react";

const LoadingScreen = ({ message, showSpinner, style }: LoadingScreenProps) => (
  <div
    className={`${style ?? "fixed"} inset-0 bg-black/30 flex items-center justify-center z-50`}
  >
    <Loader2 className="animate-spin text-white text-4xl" />
    <span className="sr-only">{message ? message : "Carregando..."}</span>
  </div>
);

export default LoadingScreen;
